export default 'PARAGRAPH/PARAGRAPH';
//# sourceMappingURL=DEFAULT_NODE.js.map